






















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component
export default class ComponentDesfazerLiberacao extends Vue {
  load: boolean = false

  get modal() { return this.getFinanceiroStore.modal.desfazerLiberacao }
  set modal(value: boolean) { this.getFinanceiroStore.setModal({ name: 'desfazerLiberacao', value }) }

  get loading() { return this.load }
  set loading(value: boolean) { this.load = value }

  async desfazerLiberacao() {
    this.loading = true
    const response: any = await this.getFinanceiroStore.desfazerLiberacao()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'A liberação foi desfeita com sucesso!', icon: 'done', color: '#2E7D32' })
      this.modal = false
      this.getFinanceiroStore.getGeracaoDeRepassesItemsVisualizar(this.getFinanceiroStore.idForLoadValidacaoEGeracaoRepasse)
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao desfazer a liberação.', icon: 'warning', color: '#C62828' })
    }
    this.loading = false
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }
}
